import React from "react";
import { RouterProvider, createBrowserRouter, createRoutesFromElements, Route } from "react-router-dom";
import primereactTR from "./locales/primereact-tr";
import { PrimeReactProvider, addLocale } from "primereact/api";
import { SettingsProvider } from "./context/SettingsContext";
import AdminLayout from "./layouts/AdminLayout";
import Dashboard from "./pages/Dashboard"; 
import CustomersPage from "./pages/Customers/CustomersPage";
import SuppliersPage from "./pages/Suppliers/SuppliersPage";
import ProductsPage from "./pages/Products/ProductsPage";
import SalesPage from "./pages/Sales/SalesPage";
import SuppliersAddPage from "./pages/Suppliers/SuppliersADdPage";
import SuppliersListPage from "./pages/Suppliers/SuppliersListPage";
import CategoriesListPage from "./pages/Categories/CategoriesListPage"; 
import CategoriesPage from "./pages/Categories/CategoriesPage";
import SalesListPage from "./pages/Sales/SalesListPage";
import ProductSalesPage from "./pages/Sales/ProductSalesPage";
import RetailSalesListPage from "./pages/Sales/RetailSalesListPage";
import CustomerListPage from "./pages/Customers/CustomerListPage";
import CustomerAddPage from "./pages/Customers/CustomerAddPage";
import CustomerEditPage from "./pages/Customers/CustomerEditPage";
import CustomerDetailPage from "./pages/Customers/CustomerDetailPage";
import CustomerImportPage from "./pages/Customers/CustomerImportPage";
import EmployeeListPage from "./pages/Employees/EmployeeListPage";
import EmployeeAddEditPage from "./pages/Employees/EmployeeAddEditPage";
import EmployeeDetailPage from "./pages/Employees/EmployeeDetailPage";
import Login from "./pages/Login";
import ProtectedRoute from "./components/ProtectedRoute";
import CategoriesAddPage from "./pages/Categories/CategoriesAddPage";
import CategoryEditPage from "./pages/Categories/CategoryEditPage";
import ProductsEditPage from "./pages/Products/ProductEditPage"; 
import ProductsListPage from "./pages/Products/ProductsListPage";
import ProductsAddPage from "./pages/Products/ProductsAddPage";
import ProductImportPage from "./pages/Products/ProductImportPage";
import ProductDetailPage from "./pages/Products/ProductDetailPage";
import SuppliersEditPage from "./pages/Suppliers/SuppliersEditPage";
import SupplierDetail from "./pages/Suppliers/SupplierDetail";
import SupplierImportPage from "./pages/Suppliers/SupplierImportPage";
import SupplierPurchaseCreatePage from "./pages/Suppliers/SupplierPurchaseCreatePage";
import SupplierReturnCreatePage from "./pages/Suppliers/SupplierReturnCreatePage";
import FinancePage from "./pages/Finance/FinancePage";
import PaymentsPage from "./pages/Finance/PaymentsPage";
import CollectionsPage from "./pages/Finance/CollectionsPage";
import ChequeListPage from "./pages/Finance/ChequeListPage";
import OwnChequeListPage from "./pages/Finance/OwnChequeListPage";
import PromissoryNoteListPage from "./pages/Finance/PromissoryNoteListPage";
import OwnPromissoryNoteListPage from "./pages/Finance/OwnPromissoryNoteListPage";
import FinancialAccountsListPage from "./pages/Finance/FinancialAccountsListPage";
import FinancialAccountEditPage from "./pages/Finance/FinancialAccountEditPage";
import FinancialAccountDetailPage from "./pages/Finance/FinancialAccountDetailPage";
import CreditCardInstallmentsPage from "./pages/Finance/CreditCardInstallmentsPage";
import ProductReturnListPage from "./pages/Returns/ProductReturnListPage";
import WarehouseListPage from "./pages/Warehouses/WarehouseListPage";
import WarehouseAddPage from "./pages/Warehouses/WarehouseAddPage";
import WarehouseEditPage from "./pages/Warehouses/WarehouseEditPage";
import WarehouseDetailPage from "./pages/Warehouses/WarehouseDetailPage";
import ProfilePage from "./pages/Profile/ProfilePage";
import ExpenseListPage from "./pages/Expenses/ExpenseListPage";
import ExpenseAddPage from "./pages/Expenses/ExpenseAddPage";
import ExpenseEditPage from "./pages/Expenses/ExpenseEditPage";
import ExpenseCategoryListPage from "./pages/Expenses/ExpenseCategoryListPage";
import ExpenseCategoryAddPage from "./pages/Expenses/ExpenseCategoryAddPage";
import ExpenseCategoryEditPage from "./pages/Expenses/ExpenseCategoryEditPage";
import SystemAdminPage from "./pages/Admin/SystemAdminPage"; 
import ResetPassword from "./pages/ResetPassword";
import SalesReportPage from "./pages/Reports/SalesReportPage";
import ExpenseReportPage from "./pages/Reports/ExpenseReportPage";
import ProfitLossReportPage from "./pages/Reports/ProfitLossReportPage";
import StockReportPage from "./pages/Reports/StockReportPage";
import CustomerBalanceReportPage from "./pages/Reports/CustomerBalanceReportPage";
import BranchReportPage from "./pages/Reports/BranchReportPage";
import AccountTransactionsReportPage from "./pages/Reports/AccountTransactionsReportPage";
import FinancialOverviewReportPage from "./pages/Reports/FinancialOverviewReportPage";
import StockMovementListPage from "./pages/Stock/StockMovementListPage";
import ManualStockAdjustmentPage from "./pages/Stock/ManualStockAdjustmentPage";
import StockTransferPage from "./pages/Stock/StockTransferPage";
import CriticalStockPage from "./pages/Stock/CriticalStockPage";
import PrintSettingsPage from "./pages/Settings/PrintSettingsPage";
import QuotationPrintSettingsPage from "./pages/Settings/QuotationPrintSettingsPage";
import ViewSettingsPage from "./pages/Settings/ViewSettingsPage";
import SettlementPage from "./pages/Settlements/SettlementPage";
import SettlementListPage from "./pages/Settlements/SettlementListPage";
import SettlementEditPage from "./pages/Settlements/SettlementEditPage";
import QuotationListPage from "./pages/Quotations/QuotationListPage";
import QuotationAddEditPage from "./pages/Quotations/QuotationAddEditPage";
import PriceTariffsPage from "./pages/PriceTariffs/PriceTariffsPage";
import PriceTierAddEditPage from "./pages/PriceTariffs/PriceTierAddEditPage";
import BranchesPage from "./pages/Settings/BranchesPage";
import WorkTrackingPage from "./pages/WorkTracking/WorkTrackingPage";

const router = createBrowserRouter(
  createRoutesFromElements(
    <>
      <Route path="/login" element={<Login />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/" element={
        <ProtectedRoute>
          <AdminLayout />
        </ProtectedRoute>
      }>
        <Route index element={<Dashboard />} />
        <Route path="customers" element={<CustomersPage/>} >
          <Route index element={<CustomerListPage/>} />
          <Route path="detail/:id" element={<CustomerDetailPage/>} />
          <Route path="add" element={<CustomerAddPage/>} />
          <Route path="import" element={<CustomerImportPage />} />
          <Route path="edit/:id" element={<CustomerEditPage />} />
        </Route>
        <Route path="suppliers" element={<SuppliersPage/>} >
          <Route index element={<SuppliersListPage/>} />
          <Route path="add" element={<SuppliersAddPage/>} />
          <Route path="import" element={<SupplierImportPage />} />
          <Route path="detail/:id" element={<SupplierDetail/>} />
          <Route path="edit/:id" element={<SuppliersEditPage/>} />
          <Route path="purchase" element={<SupplierPurchaseCreatePage/>} />
          <Route path="purchase/edit/:id" element={<SupplierPurchaseCreatePage/>} />
          <Route path="return" element={<SupplierReturnCreatePage/>} />
        </Route>
        <Route path="products" element={<ProductsPage/>} >
          <Route index element={<ProductsListPage/>} />
          <Route path="edit/:id" element={<ProductsEditPage />} />
          <Route path="detail/:id" element={<ProductDetailPage />} />
          <Route path="add" element={<ProductsAddPage/>} />
          <Route path="import" element={<ProductImportPage />} />
          <Route path="price-tiers" element={<PriceTariffsPage />} />
          <Route path="price-tiers/add" element={<PriceTierAddEditPage />} />
          <Route path="price-tiers/edit/:id" element={<PriceTierAddEditPage />} />
        </Route>
        <Route path="sales" element={<SalesPage/>} >
          <Route index element={<SalesListPage/>} />
          <Route path="productsale" element={<ProductSalesPage/>}/>
          <Route path="edit/:id" element={<ProductSalesPage/>}/>
          <Route path="retail" element={<RetailSalesListPage/>}/>
        </Route>
        <Route path="returns" element={<ProductReturnListPage />} />
        <Route path="quotations">
          <Route index element={<QuotationListPage />} />
          <Route path="add" element={<QuotationAddEditPage />} />
          <Route path="edit/:id" element={<QuotationAddEditPage />} />
        </Route>
        <Route path="employees">
          <Route index element={<EmployeeListPage />} />
          <Route path="add" element={<EmployeeAddEditPage />} />
          <Route path="edit/:id" element={<EmployeeAddEditPage />} />
          <Route path="detail/:id" element={<EmployeeDetailPage />} />
        </Route>
        <Route path="expenses">
          <Route index element={<ExpenseListPage />} />
          <Route path="add" element={<ExpenseAddPage />} />
          <Route path="edit/:id" element={<ExpenseEditPage />} />
          <Route path="categories" element={<ExpenseCategoryListPage />} />
          <Route path="categories/add" element={<ExpenseCategoryAddPage />} />
          <Route path="categories/edit/:id" element={<ExpenseCategoryEditPage />} />
        </Route>
        <Route path="categories" element={<CategoriesPage/>} >
          <Route index element={<CategoriesListPage/>} />
          <Route path="add" element={<CategoriesAddPage/>} />
          <Route path="edit/:id" element={<CategoryEditPage />} />
        </Route>
        <Route path="finance" element={<FinancePage />} >
          <Route path="payments" element={<PaymentsPage />} />
          <Route path="settlements" element={<SettlementPage />} />
          <Route path="settlements/list" element={<SettlementListPage />} />
          <Route path="settlements/edit/:id" element={<SettlementEditPage />} />
          <Route path="collections" element={<CollectionsPage />} />
          <Route path="cheques" element={<ChequeListPage />} />
          <Route path="own-cheques" element={<ChequeListPage />} />
          <Route path="promissory-notes" element={<PromissoryNoteListPage />} />
          <Route path="own-promissory-notes" element={<OwnPromissoryNoteListPage />} />
          <Route path="installments" element={<CreditCardInstallmentsPage />} />
          <Route path="accounts" element={<FinancialAccountsListPage />} />
          <Route path="accounts/add" element={<FinancialAccountEditPage />} />
          <Route path="accounts/edit/:id" element={<FinancialAccountEditPage />} />
          <Route path="accounts/detail/:id" element={<FinancialAccountDetailPage />} />
        </Route>
        <Route path="warehouses">
          <Route index element={<WarehouseListPage />} />
          <Route path="add" element={<WarehouseAddPage />} />
          <Route path="edit/:id" element={<WarehouseEditPage />} />
          <Route path="detail/:id" element={<WarehouseDetailPage />} />
        </Route>
        <Route path="stock">
          <Route path="movements" element={<StockMovementListPage />} />
          <Route path="adjustment" element={<ManualStockAdjustmentPage />} />
          <Route path="transfer" element={<StockTransferPage />} />
          <Route path="critical" element={<CriticalStockPage />} />
        </Route>
        <Route path="profile" element={<ProfilePage />} />
        <Route path="work-tracking" element={<WorkTrackingPage />} />
        <Route path="admin/panel" element={<SystemAdminPage />} />
        <Route path="reports">
           <Route path="financial-overview" element={<FinancialOverviewReportPage />} />
           <Route path="sales" element={<SalesReportPage />} />
           <Route path="expenses" element={<ExpenseReportPage />} />
           <Route path="profit-loss" element={<ProfitLossReportPage />} />
           <Route path="stock" element={<StockReportPage />} />
           <Route path="customer-balance" element={<CustomerBalanceReportPage />} />
           <Route path="branch" element={<BranchReportPage />} />
           <Route path="account-transactions" element={<AccountTransactionsReportPage />} />
        </Route>
        <Route path="settings">
          <Route path="print-templates" element={<PrintSettingsPage />} />
          <Route path="quotation-template" element={<QuotationPrintSettingsPage />} />
          <Route path="view-settings" element={<ViewSettingsPage />} />
          <Route path="branches" element={<BranchesPage />} />
        </Route>
      </Route>
    </>
  )
);

addLocale('tr', primereactTR);
 

const primeConfig = {
    locale: 'tr',
    ripple: true,
    appendTo: null,
    hideOverlaysOnDocumentScrolling: false,
};
function App() {
  return (
    <PrimeReactProvider
      value={ primeConfig }
    >
      <SettingsProvider>
        <RouterProvider router={router} />
      </SettingsProvider>
    </PrimeReactProvider> 
  );
}

export default App;
